import { fetchLiveJobPipelineDrilldown } from './actions';
import { buildReportsSlice } from '../common/ats-filters';

const constructDrilldownData = (payload, drilldown) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;
  const k5Map = payload?.data?.lookups?.k5;
  const k6Map = payload?.data?.lookups?.k6;
  const k7Map = payload?.data?.lookups?.k7;

  if (!k1Map || !payload?.data?.table) {
    return [];
  }

  return payload.data.table.map((data) => {
    const [
      dt,
      k1,
      time_in_stage,
      is_overdue,
      k2,
      k3,
      k4,
      stage_name,
      k5,
      k6,
      department_name,
      office_names,
      workplace,
      work_type,
      k7,
      ...rest
    ] = data;

    // For hired metric, API returns: hired_at, time_to_hire, employee_start_date, current_stage_sla_hours (rest indices 0–3)
    // For other metrics, API returns: offer_first_generated_at, offer_status, time_to_offer, employee_start_date, hired_at, time_to_hire, current_stage_sla_hours (indices 0–6)
    const current_stage_sla_hours =
      rest.length > 0 ? rest[rest.length - 1] : undefined;
    const restWithoutSla = rest.length > 0 ? rest.slice(0, -1) : rest;
    const isHiredMetric = drilldown?.metric === 'hired';
    const hired_at = isHiredMetric ? restWithoutSla[0] : restWithoutSla[4];
    const time_to_hire = isHiredMetric ? restWithoutSla[1] : restWithoutSla[5];
    const employee_start_date = isHiredMetric
      ? restWithoutSla[2]
      : restWithoutSla[3];
    const offer_first_generated_at = isHiredMetric
      ? undefined
      : restWithoutSla[0];
    const offer_status = isHiredMetric ? undefined : restWithoutSla[1];
    const time_to_offer = isHiredMetric ? undefined : restWithoutSla[2];

    // k1: applicant, k2: source, k3: credited_to, k4: job, k5: recruiters, k6: hiring_managers, k7: created_by
    return {
      ...k1Map[k1],
      dt,
      time_in_stage,
      is_overdue,
      source: k2Map?.[k2],
      credited_to: k3Map?.[k3],
      job: k4Map?.[k4],
      stage_name,
      recruiters: k5Map?.[k5],
      hiring_managers: k6Map?.[k6],
      department_name,
      office_names,
      workplace,
      work_type,
      created_by: k7Map?.[k7],
      offer_first_generated_at,
      offer_status,
      time_to_offer,
      employee_start_date,
      hired_at,
      time_to_hire,
      current_stage_sla_hours,
    };
  });
};

const initialState = {
  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  totalCount: 0,
  currentDrillPage: 1,
  searchTerm: null,
};

const extraReducers = {
  [fetchLiveJobPipelineDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown?.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchLiveJobPipelineDrilldown.fulfilled]: (
    state,
    { meta, payload = {} }
  ) => {
    if (!payload) return;

    state.isDrillLoading = false;
    state.initialLoading = false;
    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload, drilldown);
    state.totalCount = payload?.data?.pagination?.total_count ?? 0;

    if (drilldown?.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown?.page ?? 1;
  },
  [fetchLiveJobPipelineDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsLiveJobPipelineReport',
  initialState,
  extraReducers,
});

export const { applySearch, resetDrillDown } = actions;
export default reducer;
